import { render, staticRenderFns } from "./BearingTasksView.vue?vue&type=template&id=2d23bebf&scoped=true&"
import script from "./BearingTasksView.vue?vue&type=script&lang=ts&"
export * from "./BearingTasksView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23bebf",
  null
  
)

export default component.exports